import "./Button.css";

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}) {
  return (
    <button
      className={`wc-btn wc-btn-${variant} wc-btn-${size} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
